import { ChevronLeftIcon } from "@heroicons/react/24/outline";

import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { useCalendar } from "../../context/hook";
import { cn } from "../../../../lib/utils";
import { Periodicity } from "../../context/types";

export default function CalendarFilters({
  displayTodayButton = true,
}: {
  displayTodayButton?: boolean;
}) {
  const { onPeriodChange, periodicity, setPeriodicity, periodDescription } =
    useCalendar();

  const formatPeriodicity = (p: Periodicity) => {
    switch (p) {
      case Periodicity.MONTH:
        return "Mois";
      case Periodicity.QUARTER:
        return "Trimestre";
      case Periodicity.WEEK:
        return "Semaine";
    }
  };

  const periodicityButton = (
    p: Periodicity,
    isFirst: boolean,
    isLast: boolean
  ) => {
    const periodicityButtonStyle = cn(
      "text-xs text-primary cursor-pointer bg-dark border border-border py-1 px-2 hover:bg-input",
      periodicity === p && "bg-input text-accent",
      isFirst && "rounded-l-md border-r-0",
      isLast && "rounded-r-md border-l-0"
    );

    return (
      <div className={periodicityButtonStyle} onClick={() => setPeriodicity(p)}>
        {formatPeriodicity(p)}
      </div>
    );
  };

  const periodicitySelection = () => {
    return (
      <div className="flex items-center select-none">
        {periodicityButton(Periodicity.WEEK, true, false)}
        {periodicityButton(Periodicity.MONTH, false, false)}
        {periodicityButton(Periodicity.QUARTER, false, true)}
      </div>
    );
  };

  const periodSelection = () => {
    return (
      <div className="flex items-center justify-end gap-2">
        <div className="flex items-center gap-2 select-none">
          <div className="flex items-center font-semibold">
            {periodDescription}
          </div>

          <ChevronLeftIcon
            className="w-5 h-5 bg-dark border border-border hover:bg-input cursor-pointer rounded-full p-1"
            onClick={() => onPeriodChange("left")}
          />
          <ChevronRightIcon
            className="w-5 h-5 bg-dark border border-border hover:bg-input cursor-pointer rounded-full p-1"
            onClick={() => onPeriodChange("right")}
          />
        </div>

        {displayTodayButton ? (
          <div
            className="text-xs text-primary cursor-pointer bg-dark border border-border rounded-md py-1 px-2 hover:bg-input select-none"
            onClick={() => onPeriodChange("today")}
          >
            Aujourd'hui
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <div className="flex items-center justify-between">
      {periodicitySelection()}

      {periodSelection()}
    </div>
  );
}
